import maxBy from 'ramda/es/maxBy'

export const calculatePoints = answer => {

    const q         = answer.question()
    const selfRating    = answer.userInput().find( x => x.key==='selfRating')
    const noInput       = !selfRating || !selfRating.value

      /**
     * if countPerAnswer() ( wertung = 'einzeln' ), the max points are the number of questions (= all correct)
     * from the selfRating will be calculated how many questions were answered correctly. The number of correct
     * question equals number of points
     * 
     * e.g. maxPoints = 10, 40 questions
     * user set for himself 5 points, means he thinks he got 20 questions correct
     * "Für jeweils vier gefundene Wörter können Sie sich 1 Punkt gutschreiben."
     * then he will get 20 points.
     */
    if (selfRating && q.countPerAnswer()) {
        const findMax   = maxBy(x => x.punkte)
        const startVal  = { punkte:0 }
        const maxPoints = q.points().reduce(findMax, startVal).punkte

        // Convert self-rating points to equivalent number of correct questions
        // e.g. if maxPoints=10 and user rated 5 points, that's 50% = 20 out of 40 questions
        // The score IS the number of correct questions
        const equivalentCorrectQuestions = (selfRating.value.punkte / maxPoints) * q.realQuestionsCount()

        return equivalentCorrectQuestions;
    }

    return noInput ? 0 : Number(selfRating.value.punkte)
}